/*
 * Title: 승인잔액 조회 서비스
 * Author: KimHyunSoo
 * Date: 2021-04-26
*/

/*
2025.2.25
{
    "result": "200",  // 응답 코드 (성공)
    "resultMessage": "SUCCESS",  // 응답 메시지
    "siteNo": "KR",  // 요청한 사이트 번호
    "locale": "ko_KR",  // 요청한 사이트 언어 및 번호
    "time": "2025-02-25T15:58:36.727828991+09:00[Asia/Seoul]",  // 응답 시간
    "items": [
        {
        "notiNo": "02061",  // 공지사항 ID
        "clssNm": "상품공지",  // 분류명
        "clssDtlNm": "시즌오픈",  // 상세 분류명
        "notiTitle": "TEST 공지",  // 제목
        "notiCont": "TEST",  // 내용
        "regDtime": "2025-02-04 17:14:37",  // 등록일
        "uptDtime": "2025-02-05 10:25:08",  // 수정일
        "selCnt": 9  // 조회수
        }
    ]
*/

import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleLang from '../common/lang';
import GentleComponentBubble from '../component/bubble';
import GentleComponentButton from '../component/button';
import GentleComponentQuickReply from '../component/quickReply';
import GentleProxy from '../common/proxy';
import language from '../lang';
import GentleAppState from '../common/appstate';

var GentleServiceNotice = Object.create( GentleWidget,{
    sponserId:{ writable: true, configurable: false, enumerable: true},
    sponserName: { writable: true, configurable: false, enumerable: true}
})

const noticeType = {
    Member: "N01",
    Sales: "N02",
    Service: "N03",
    Product: "N04",
}

// 하이브리드 앱 분기 체크
const browserInfo = window.navigator.userAgent;
const isHybrid = browserInfo.includes('MARKET_GOOGLE') || browserInfo.includes('MARKET_APPSTORE');

GentleServiceNotice.card = function(element){            
    let html = `
    <div>
    <li>
        <div class="notice-info">
            <span class="time-label">${element.changed}</span>
        </div>
        <h3>${element.label}</h3>
    </li>
    </div>
    `
    const $card = $(html);
    return $card
};

const getParam = function(type){
    let param = {   // 비로그인
        IsCommonGubun: true,
        SearchWGubun: 0,
        Mode:1,
        SearchCustNo: '',
        IsReadyReOpenSearch: '',
        IsRegisterReOpenSearch: '',
    };
    
    if(GentleAppState.isLogin){
        console.log('type>', type);
        switch (type) {
            case noticeType.Member:
                param.IsCommonGubun = true;
                param.SearchCustNo = GentleAppState.custNo;
                param.SearchWGubun = 0;
                param.Mode = 0;
            break;
            case noticeType.Sales:
                param.IsCommonGubun = false;
                param.IsReadyReOpenSearch = true;
                param.IsRegisterReOpenSearch = true;
                param.SearchCustNo = GentleAppState.custNo;
                param.Mode = 0;            
                break;
            case noticeType.Service:
                param.IsCommonGubun = true;
                param.SearchCustNo = GentleAppState.custNo;
                param.SearchWGubun = 2;
                break;
            case noticeType.Product:    
                param.IsCommonGubun = true;
                param.SearchCustNo = GentleAppState.custNo;
                param.SearchWGubun = 0;
                param.Mode = 1;
                break;            
            default:
                break;
        }            
    }

    return param;
}


GentleServiceNotice.main = function(type = "N01"){
    let mainCategory = type
    const component =  Object.create(this);
    console.log('GentleServiceNotice.main>', mainCategory);

    // type : 회원공지(1), 품절/완판/재판매공지(2), 제휴서비스공지(3), 상품공지(4) / (비로그인)
    const cards = [];

    // api
    const request = function(type){
        const loading = Object.create( GentleComponentBubble );   
        // console.log("123123123123123", type)
        loading.createComponent({"loading": true});
        loading.insert();    

        const onSuccess = function(data){
            loading.remove();
            // console.log(data.result)
            switch(data.result){
            case "200":
                // console.log('data>', data);
                // const { Data } = data; 기존 api
                const { items } = data; // items 라는 배열로 들어옴
                if(items){
                  const itemsFilter = items.filter(item => {
                  return item.label !== null
                })
                  render(itemsFilter);
                }else{
                  {
                      const html = GentleLang.translateService(language.notice, language.notice.type.NotFound);
                   var bubble = Object.create( GentleComponentBubble );   
                   bubble.createComponent({
                           html,
                   });
                   bubble.insert();  
                   }
                  {
                      const text = GentleLang.translateService(language.notice, language.notice.type.FAQ);
                      const option = [{
                          text: text,
                          user: 'user',
                      }, ]
                      var button = Object.create(GentleComponentButton);
                      button.createComponent(option);
                      button.insert();
                  }                    
                }
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log("공지사항 실패", data)
            loading.remove();
        }

        const pageSize = 3;
        const proxy = Object.create(GentleProxy);

        // let param = getParam(type);
        // param.PageNo = 1;
        // param.PageSize = pageSize;
        // console.log("type ----->?", type)
        // proxy.request("global-notice", {mainCategory:mainCategory}, onSuccess, onFailed );
        // --> 2025 공지사항 목록
        proxy.request("2025-notice", {notiClssCd:mainCategory}, onSuccess, onFailed );
    }

    const render = function(data){
        // console.log('items>', data);
        const array = data;

        // 봇버블
        {
            const html = GentleLang.translateService(language.notice, language.notice.type.Bot);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
            console.log('bubble>', bubble.getId());
        }

        let button_title = GentleLang.translateService(language.notice, language.notice.type.ProductMore); // 비로그인
        if(GentleAppState.isLogin)   
        {
            switch(type){
                case noticeType.Member:
                    button_title = GentleLang.translateService(language.notice, language.notice.type.More);
                break;                
                case noticeType.Sales:
                    button_title = GentleLang.translateService(language.notice, language.notice.type.SalesMore);
                break;                
                case noticeType.Service: // 
                    button_title = GentleLang.translateService(language.notice, language.notice.type.ServiceMore);
                break;
                case noticeType.Product: // 
                    button_title = GentleLang.translateService(language.notice, language.notice.type.ProductMore);
                break;                
            }
        }         

        {
            let html = `
            <div class="card-view">
                <ul class="notice" name="list">
                </ul>
                <div class="gentle-button-group" style="margin:10px">
                    <div class="wide-button">
                        <button type="button" class="primary default">${button_title}</button>
                    </div>
                </div>
            </div>`

            // component 초기화. 이 코드 후에 레퍼런스로 접근
            {
                let $container = $(html)
                component.setPrefix("notice");
                component.init($container);
                component.insert();
            }

            // button\
            {
                component.find('button').bind('click',function() {
                    console.log('더보기')

                    GentleServiceNotice.popupList(type);
                }
            );
            }

            const max = 3;  // 최대 3개만            
            for (let index = 0; index < array.length && index < max; index++) {
              const element = array[index];
              const $card = GentleServiceNotice.card(element);

              // console.log('asdfasdfasdf',GentleServiceNotice.card(element)[index])
 
              cards.push($card);
              $card.find('li').bind('click', function(){
                console.log('공지사항 선택', element);

                const {id} = element;
                // 2022-api 공지사항목록 : 아래 항목이 없슴
                // const {MobileDetailUrl, PCDetailUrl} = element;

                // const url = `https://shop.atomy.com/customer/notice/detail?id=${notiNo}`
                const url = `https://kr.atomy.com/cst/notice/dtl?notiNo=${id}`

                isHybrid ? window.open(url, '_self') : GentleAppState.isPc ? window.open(url) 
                    : window.location.href = url;
              });
        
              component.find('[name="list"]').append($card); 
            }
        }

        // quickReplay
        if(GentleAppState.isLogin)
        {
            let buttons;
            const titleNotice = GentleLang.translateService(language.notice, language.notice.type.Notice);
            const titleSales = GentleLang.translateService(language.notice, language.notice.type.Sales);
            const titleService = GentleLang.translateService(language.notice, language.notice.type.Service);
            const titleProduct = GentleLang.translateService(language.notice, language.notice.type.Product);
            switch (type) {
                case noticeType.Member:
                    buttons = [
                        {
                            send: false,
                            title: titleSales,
                            text: titleSales,
                            onClick: function() {
                                console.log('품절/완판...');
                                GentleServiceNotice.main("N02");
                            }
                        },
                        {
                            send: false,
                            title: titleService,
                            text: titleService,
                            onClick: function() {
                                console.log('제휴');
                                GentleServiceNotice.main("N03");
                            }
                        },
                        {
                            send: false,
                            title: titleProduct,
                            text: titleProduct,
                            onClick: function() {
                                console.log('상품');
                                GentleServiceNotice.main("N04");
                            }
                        },
                    ];
                break;                
                case noticeType.Sales:
                    buttons = [
                        {
                            send: false,
                            title: titleNotice,
                            text: titleNotice,
                            onClick: function() {
                                console.log('회원공지');
                                GentleServiceNotice.main("N01");
                            }
                        },
                        {
                            send: false,
                            title: titleService,
                            text: titleService,
                            onClick: function() {
                                console.log('제휴');
                                GentleServiceNotice.main("N03");
                            }
                        },
                        {
                            send: false,
                            title: titleProduct,
                            text: titleProduct,
                            onClick: function() {
                                console.log('상품');
                                GentleServiceNotice.main("N04");
                            }
                        },
                    ];
                break;                
                case noticeType.Service:
                    buttons = [
                        {
                            send: false,
                            title: titleNotice,
                            text: titleNotice,
                            onClick: function() {
                                console.log('회원공지');
                                GentleServiceNotice.main("N01");
                            }
                        },
                        {
                            send: false,
                            title: titleSales,
                            text: titleSales,
                            onClick: function() {
                                console.log('품절/완판...');
                                GentleServiceNotice.main("N02");
                            }
                        },
                        {
                            send: false,
                            title: titleProduct,
                            text: titleProduct,
                            onClick: function() {
                                console.log('상품');
                                GentleServiceNotice.main("N04");
                            }
                        },
                    ];
                break;
                case noticeType.Product:
                    buttons = [
                        {
                            send: false,
                            title: titleNotice,
                            text: titleNotice,
                            onClick: function() {
                                console.log('회원공지');
                                GentleServiceNotice.main("N01");
                            }
                        },
                        {
                            send: false,
                            title: titleSales,
                            text: titleSales,
                            onClick: function() {
                                console.log('품절/완판...');
                                GentleServiceNotice.main("N02");
                            }
                        },
                        {
                            send: false,
                            title: titleService,
                            text: titleService,
                            onClick: function() {
                                console.log('제휴');
                                GentleServiceNotice.main("N03");
                            }
                        },
                    ];
                break;            
                default:
                    break;
            }
            var quickReply = Object.create( GentleComponentQuickReply);   
            quickReply.createComponent(buttons);
            quickReply.insert();
        }
        GentleUtil.timeStamp();
    };

    request();
}

GentleServiceNotice.popupList = function(type){
    //20221017
    // GentleUtil.updateSSOToken();

    // element 참조 변수 선언
    const cards = [];
    let curPage = 0;

    // api
    const request = function(type, page){
        const PageSize = 10;

        const onSuccess = function(data){
            console.log('onSuccess>', data);
            switch(data.result){
            case "200":
                const { items } = data;
                // 2022-api : 공지사항목록
                // const { items:Data } = data;
                console.log('Data>', items);
                
                // rows = rows.concat(Data.List);
                // addCard(Data.List);

                if(items.length > 0){
                  const itemsFilter = items.filter(item => {
                    return item.label !== null
                  })
                    curPage = page;
                    render(itemsFilter);   // (array)
                }    
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        // const param = {PageNo, PageSizesize};

        // todo : 파라미터 구성
        let param = getParam(type);
        param.PageNo = page;
        param.PageSize = PageSize;

        proxy.request("global-notice", {mainCategory:type}, onSuccess, onFailed );
    }
    request(type, 1);

    const render = function(array){
        // 삽입형
        {
            const count = array.length;

            // todo : 분기에 따른 타이틀
            const title = GentleLang.translateService(language.notice, language.notice.type.More) ; // 하위회원 선택
            // const comment = GentleLang.translateService(language.notice, language.notice.type.Comment, {count});
            const button_title = GentleLang.translateService(language.notice, language.notice.type.Next);

            let html = `
            <div id="notice-container">
                <p class="info-box"><img src="/assets/images/atomy/popup_informatino.png" srcset="/assets/images/atomy/popup_informatino@2x.png 2x">최근 10건의 공지사항을 보여드려요.<br>더 많은 공지사항을 보려면, 하단 버튼을 누르세요</p>
                <ul class="notice" name="list">
                </ul>
                <div id="fixed-bottom-layer">
                <div class="gentle-button-group margin-zero">
                    <div class="wide-button">
                    <button type="button" class="big square primary default">${button_title}</button>
                    </div>
                </div>
                </div>
            </div>
            `

            let $container = $(html)
            const $list = $container.find('[name="list"]');

            GentleUtil.createSlidePopup({title, content: $container});

            // button
            $container.find('button').bind('click',function() {
                console.log('더 많은 공지사항 보기 > 웹', type)
                // (GentleAppState.isPc) ? window.open(language.url.pc.SeeMoreAnnoMember) : window.open(language.url.mobile.SeeMoreAnnoMember);
                switch(type){
                    case 'N01':
                        var redirectUrl = (GentleAppState.isPc) ? (language.url.pc.SeeMoreAnnoMember) : (language.url.mobile.SeeMoreAnnoMember);
                            GentleUtil.ssoOpen(redirectUrl);
                    break;                
                    case 'N02':
                        var redirectUrl = (GentleAppState.isPc) ? (language.url.pc.SeeMoreAnnoSold) : (language.url.mobile.SeeMoreAnnoSold);
                            GentleUtil.ssoOpen(redirectUrl);
                    break;                
                    case 'N03': // 
                        var redirectUrl = (GentleAppState.isPc) ? (language.url.pc.SeeMoreAnnoAlli) : (language.url.mobile.SeeMoreAnnoAlli);
                            GentleUtil.ssoOpen(redirectUrl);
                    break;
                    case 'N04': // 
                        isHybrid ? 
                            window.open(language.url.mobile.SeeMoreAnnoProduct ,'_self')
                            : (GentleAppState.isPc) ? 
                                window.open(language.url.pc.SeeMoreAnnoProduct) 
                                : window.location.href = language.url.mobile.SeeMoreAnnoProduct;
                    break;                
                }
                // 공지사항 외부페이지로 연결
            });

            const max = 10;  // 최대 3개만
            for (let index = 0; index < array.length && index < max; index++) {
                const element = array[index];

                const $card = GentleServiceNotice.card(element);
                cards.push($card);
        
                $card.find('li').bind('click', function(){
                    console.log('공지사항 선택', element);

                    const {id} = element;

                    // const url = `https://shop.atomy.com/customer/notice/detail?id=${id}`
                    const url = `https://kr.atomy.com/cst/notice/dtl?notiNo=${id}`
                    
                    isHybrid ? 
                        window.open(url, '_self') 
                        : GentleAppState.isPc ? 
                            window.open(url)
                            : window.location.href = url;
                });
        
                $list.append($card);
            }
        }
    };
}

export default GentleServiceNotice;